export const getSystemConnections = async () => {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    if (!authToken) {
        console.error("Authorization token is missing.");
        return { bkList: [], posList: [], isSuccess: false };
    }

    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken}`,
        },
        redirect: "follow",
    };

    try {
        const response = await fetch(`${ApiURL}Common/getConnections`, requestOptions);
        const result = await response.json();
        
        if (result.success) {
            return {
                bkList: result.bkList || [],
                posList: result.posList || [],
                isSuccess: true
            };
        } else {

            return { bkList: [], posList: [], isSuccess: false };
        }
    } catch (error) {
        console.error("Error fetching system connections:", error);
        return { bkList: [], posList: [], isSuccess: false };
    }
};
